export const formatServiceTime = (date) => {
  // Parse the input date string
  var dateObject = date

  // Get day of the week, month, day, year, hours, and minutes
  var daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var dayOfWeek = daysOfWeek[dateObject.getDay()]

  var months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]
  let month = months[dateObject.getMonth()]

  let day = dateObject.getDate()
  let year = dateObject.getFullYear()
  let hours = dateObject.getHours()
  let minutes = dateObject.getMinutes()

  // Convert hours to AM/PM format
  var ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours ? hours : 12 // Handle midnight (0 hours)

  // Add leading zero for single-digit minutes
  minutes = minutes < 10 ? '0' + minutes : minutes

  // Construct the formatted date string
  var formattedDate =
    dayOfWeek +
    ', ' +
    month +
    ' ' +
    (day < 10 ? '0' + day : day) +
    ', ' +
    year +
    ' ' +
    hours +
    ':' +
    minutes +
    ' ' +
    ampm

  return formattedDate
}
